<div class="card kpi-yellow">
    <div class="card-body kpi-card">
        <h5 class="card-title">Cash flow <i class="fa fa-question-circle" matTooltipClass="tooltip-button" matTooltip="C’est un cash-flow net avant impôt. Cash-flow = Total des loyers - total des charges"></i></h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.cash_flow | number: '1.0-0' }} €
            </ng-container>
        </p>
    </div>
</div>
